import { render, staticRenderFns } from "./TableSelectiveprocess.vue?vue&type=template&id=6485090e&scoped=true&"
import script from "./TableSelectiveprocess.vue?vue&type=script&lang=js&"
export * from "./TableSelectiveprocess.vue?vue&type=script&lang=js&"
import style0 from "./TableSelectiveprocess.vue?vue&type=style&index=0&id=6485090e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6485090e",
  null
  
)

export default component.exports